export const BARS_ROUND_REWARD = 100;
export const BARS_MAX_PER_DAY = 1000;
export const WS_URL = "wss://game.bracket.fi:3001";
